import { AuctionOfferStatusEnum, CartStatusEnum } from '@onArte/shared/database';
import { AuctionInfoInterface } from '@onArte/shared/interfaces/common';

export class AuctionOfferListElementDTO {
  constructor(
    public auction: AuctionInfoInterface,
    public contextMaxPrice: number,
    public contextStatus: AuctionOfferStatusEnum,
    public cartId?: string,
    public cartStatus?: CartStatusEnum,
  ) {}
}
